exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-dropdown__menu.fts-dropdown__menu--fit li.fts-dropdown__option,.fts-dropdown__menu.fts-dropdown__menu--fit li.fts-dropdown__option .fts-dropdown__option--custom .custom-tag{white-space:normal;overflow-wrap:anywhere}.undefined-option{font-style:italic;color:var(--fts-default)}.option--tag{margin-right:.25rem;padding-left:.125rem;padding-right:.125rem;border-radius:.125rem;background-color:var(--fts-secondary);color:var(--fts-light)}", ""]);

// exports
